import React, {useEffect} from "react";
import ReportUtils from "../../../../../utils/report-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const columns = [
  "Protocolo",
  "Atendente",
  "D/H inicial",
  "Campos não preenchidos",
];
const AttendantList = ({data}) => {
  const navigate = navigateHook();
  const fillTable = (obj, idx) =>
    <tr key={idx}>
      <td className="text-left"><a className="report-link text-[#337ab7]! print:text-[#000]!" onClick={() => {
        navigate(`/reports/attendance_info?id=${obj.attendance_id}`, true)
      }}>{obj.attendance_protocol}</a></td>
      <td className="text-left">{obj.name}</td>
      <td className="text-left">{obj.attendance_start}</td>
      <td className="text-left">{obj.without_info}</td>
    </tr>

  useEffect(() => {
    if (data.length === 0) return;

    const values = data.map(obj => [
      obj.attendance_protocol,
      obj.name,
      obj.attendance_start,
      obj.without_info
    ]);

    ReportUtils.createExportableTable(columns, values, "Lista de atendimentos");
  }, [data]);

  return(
    <div className="chart-report">
      <span className="chart-title mb-3">Índices de preenchimento por atendente</span>
      <div className="mt-3">
        <table  className="table report-table" sheet-name="Lista de atendimentos">
          <thead className="thead-background table-row-group!">
          <tr>
            {columns.map((el, idx) => <th key={idx} className="text-left">{el}</th>)}
          </tr>
          </thead>
          <tbody>
          {data.map((el, idx) => fillTable(el, idx))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default AttendantList;